import React from 'react';
import FontAwesome from 'react-fontawesome';
import {Row, Col, Label, FormGroup, Input} from 'reactstrap';
import './Filter.css';
import { labels, marketTypes, profileTypes} from "../../util/constants";
import {FormControl,MenuItem, Button} from "@material-ui/core/umd/material-ui.production.min";
import MultiSelectField from "../multiSelect/multiSelect";

export default class Filter extends React.Component{
    constructor (props) {
        super(props);
        this.state = {
            registration:'',
            name:'',
            market:'',
            licensePlate:'',
            model:'',
            typeUserSelected:[],
            dataTypeUser:[{
                label:profileTypes.at,
                value:profileTypes.at
            },{
                label:profileTypes.designated,
                value:profileTypes.designated
            },{
                label:profileTypes.radar,
                value:profileTypes.radar
            }],
            dataMarket:[{
                label:marketTypes.argentina,
                value:marketTypes.argentina
            }, {
                label: marketTypes.brazil,
                value: marketTypes.brazil
            }],
        };
    }

    changeRegistration = (registration) => {
        this.setState({
            registration: registration.target.value,
        });
    };

    changeName = (name) => {
        this.setState({
            name: name.target.value,
        });
    };

    changeMarket = (market) => {
        if(market){
            this.setState({market});
        }
        else{
            this.setState({market:[]});
        }
    };

    changeLicensePlate = (plate) => {
        this.setState({
            licensePlate: plate.target.value,
        });
    };

    changeModel = (model) => {
        this.setState({
            model: model.target.value,
        });
    };

    changeTypeUser = (typeUserSelected) => {
        if(typeUserSelected){
            this.setState({typeUserSelected});
        }
        else{
            this.setState({typeUserSelected:[]});
        }
    };

    componentWillMount (){

    };

    search = (event) =>{
        event.preventDefault();
        var params = {};

        if(this.state.typeUserSelected && this.state.typeUserSelected.value){
            params = Object.assign(params, {profile_type:this.state.typeUserSelected.value});
        }
        if(this.state.registration.length > 0){
            params = Object.assign(params, {id_user: this.state.registration});
        }
        if(this.state.name.length > 0){
            params = Object.assign(params, {user_name: this.state.name});
        }
        if(this.state.market && this.state.market.value){
            params = Object.assign(params,{ market: this.state.market.value});
        }
        if(this.state.licensePlate.length > 0){
            params = Object.assign(params,{license_plate: this.state.licensePlate});
        }

        this.props.search(params);
    };

    menuItems = (items) =>  {
        if(items.length == 0 || items[0].value !== labels.all){
            items.unshift({value:labels.all,label:labels.all});
        }

        return items.map((item) => (
            <MenuItem  key={item.value} value={item.value}>{item.label}</MenuItem>
        ));
    };

    render() {
        return (
            <div className="div-margin-top fieldset-filter form-group container">
                <Row className="fieldset-board" >
                    <Col className="col-md-2"/>
                    <Col className="col-md-3">
                        <FormGroup>
                            <Label for="registration">{labels.registration}</Label>
                            <Input name="registration" id="registration" placeholder={labels.registration}
                                   value={this.state.registration} onChange={evt => this.changeRegistration(evt)}/>
                        </FormGroup>
                    </Col>
                    <Col className="col-md-3">
                        <FormGroup>
                            <Label for="name">{labels.name}</Label>
                            <Input name="name" id="name" placeholder={labels.name}
                                   value={this.state.name} onChange={evt => this.changeName(evt)}/>
                        </FormGroup>
                    </Col>
                    <Col className="col-md-3">
                        <Label >
                            {labels.profile}
                        </Label>
                        <MultiSelectField id="multiSelectProfile" data={this.state.dataTypeUser} multi={false} handleSelectChange={this.changeTypeUser}
                                          valuesSelected={this.state.typeUserSelected} placeHolder={labels.profile} />
                    </Col>
                    <Col className="col-md-2"/>
                </Row>

                <Row className="fieldset-board" >
                    <Col className="col-md-2"/>
                    <Col className="col-md-3">
                        <label >
                            {labels.market}
                        </label>
                        <MultiSelectField id="multiSelectMarket" data={this.state.dataMarket} multi={false} handleSelectChange={this.changeMarket}
                                          valuesSelected={this.state.market} placeHolder={labels.market} />
                    </Col>
                    <Col className="col-md-3 div-margin-right">
                        <FormGroup>
                            <Label for="licensePlate">{labels.plateVehicle}</Label>
                            <Input name="licensePlate" id="licensePlate" placeholder={labels.plateVehicle}
                                   value={this.state.licensePlate} onChange={evt => this.changeLicensePlate(evt)}/>
                        </FormGroup>
                    </Col>
                    <Col className="col-md-2"/>
                </Row>
                <Row>
                    <div className="div-button">
                        <FormControl className="buttonSearch">
                            <Button variant="contained"  color="primary" onClick={this.search}>
                                <FontAwesome name='search'/> &nbsp;&nbsp;{labels.search}
                            </Button>
                        </FormControl>
                    </div>
                </Row>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/filter/Filter.js